import * as React from 'react';
import {Button, ButtonToolbar, Modal} from 'reactstrap';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';

interface ConfirmationModalProps {
    title: string;
    message: string;
    color: string;
    colored: boolean;
    header?: boolean;
    handleOk: any;
    toggle: any;
    isOpen: boolean;
}

class ConfirmationModal extends React.PureComponent<ConfirmationModalProps> {

    constructor(props) {
        super(props);
        this.state = {};
    }

    private handleOk = () => {
        this.props.handleOk();
        this.props.toggle();
    };

    public render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}
                   className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                <div className='modal__header'>
                    <span className='lnr lnr-cross modal__close-btn' onClick={this.props.toggle}/>
                    <AlertCircleOutlineIcon className={'modal__title-icon'}/>
                    <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                </div>
                <div className='modal__body'>
                    {this.props.message}
                </div>
                <ButtonToolbar className='modal__footer'>
                    <Button onClick={this.props.toggle}>Cancelar</Button>{' '}
                    <Button outline={this.props.colored} color={this.props.color}
                            onClick={this.handleOk}>Aceptar</Button>
                </ButtonToolbar>
            </Modal>
        );
    }
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/common/modal/confirmation-modal.tsx